const getters = {
    isTenantBrandingCacheValid: (state) =>
        Boolean(state.tenantBranding.data) &&
        Boolean(state.tenantBranding.expiredAt) &&
        Date.now() < state.tenantBranding.expiredAt,
    // Atado al tenant activo: en Modo Admin cambiar de tenant la invalida.
    isCatalogPreviewCacheValid: (state, _getters, rootState) =>
        Boolean(state.catalogPreview.data) &&
        state.catalogPreview.tenantId === rootState.auth.tenantId &&
        Date.now() < state.catalogPreview.expiredAt
};

export default getters;
